angular.module('TetherApp').controller('ListenerController', [
    '$window',
    '$location',
    '$anchorScroll',
    '$timeout',
    'listenerService',
    'eventActionService',
    'shortcodeService',
    'keywordService',
    'experienceService',
    'listService',
    function (
        $window,
        $location,
        $anchorScroll,
        $timeout,
        listenerService,
        eventActionService,
        shortcodeService,
        keywordService,
        experienceService,
        listService
    ) {
        let self = this;

        // START: FORM
        self.hasDates = false;
        self.formTether = {};
        self.formTether.start_at = new Date();
        self.formTether.start_at_hour = 0;
        self.formTether.start_at_minute = 0;
        self.formTether.start_at_second = 0;
        self.formTether.start_at.setHours(self.formTether.start_at_hour);
        self.formTether.start_at.setMinutes(self.formTether.start_at_minute);
        self.formTether.start_at.setSeconds(self.formTether.start_at_second);
        self.formTether.end_at = new Date();
        self.formTether.end_at_hour = 23;
        self.formTether.end_at_minute = 59;
        self.formTether.end_at_second = 59;
        self.formTether.end_at.setHours(self.formTether.end_at_hour);
        self.formTether.end_at.setMinutes(self.formTether.end_at_minute);
        self.formTether.end_at.setSeconds(self.formTether.end_at_second);
        self.hours = range(0, 23);
        self.minutes = range(0, 59);
        self.seconds = range(0, 59);
        self.selectedIndex = 0;

        self.perPageChanged = function () {
            let form = window.document.querySelector('form#query_form');
            if (form) {
                $timeout(function () {
                    form.submit();
                });
            }
        };

        self.setStartDate = function (startDate) {
            if (startDate != null) {
                self.formTether.start_at = new Date(startDate);
                self.formTether.start_at_hour = self.formTether.start_at.getHours();
                self.formTether.start_at_minute = self.formTether.start_at.getMinutes();
                self.formTether.start_at_second = self.formTether.start_at.getSeconds();
            }
        };

        self.setEndDate = function (endDate) {
            if (endDate != null) {
                self.formTether.end_at = new Date(endDate);
                self.formTether.end_at_hour = self.formTether.end_at.getHours();
                self.formTether.end_at_minute = self.formTether.end_at.getMinutes();
                self.formTether.end_at_second = self.formTether.end_at.getSeconds();
            }
        };

        self.startDateChange = function () {
            self.formTether.start_at.setHours(self.formTether.start_at_hour);
            self.formTether.start_at.setMinutes(self.formTether.start_at_minute);
            self.formTether.start_at.setSeconds(self.formTether.start_at_second);
        };

        self.endDateChange = function () {
            self.formTether.end_at.setHours(self.formTether.end_at_hour);
            self.formTether.end_at.setMinutes(self.formTether.end_at_minute);
            self.formTether.end_at.setSeconds(self.formTether.end_at_second);
        };

        self.actionChange = function () {
            for (let index in self.eventActions) {
                if (self.eventActions[index].hasOwnProperty('id')
                    && self.eventActions[index].hasOwnProperty('name')
                    && self.eventActions[index]['id'] == self.event_action_id) {
                    self.event_action_name = self.eventActions[index]['name'];
                }
            }
        };
        // END: FORM

        self.delete = function(listenerId) {
            if($window.confirm('Are you sure you want to delete this tether?')) {
                listenerService.deleteListener(listenerId)
                    .then(onListenerDelete, onError);
            }
        };

        let onListenerDelete = function (data) {
            $window.location.reload();
        };

        // START: CAMPAIGN PAGE
        self.loadStatus = false;
        self.isCreateOpen = false;
        self.tether = {};
        self.openStatus = [];
        self.updateErrors = {};
        self.editingTethers = {};

        self.init = function (campaignId, clientId, sendTos, optInTypes) {
            self.campaignId = campaignId;
            self.tether.campaign_id = campaignId;
            self.tether.client_id = clientId;
            self.sendTos = sendTos;
            if (self.sendTos != undefined) {
                self.tether.send_to = sendTos[0].value;
            }
            self.optInTypes = optInTypes;
            if (self.optInTypes != undefined) {
                self.tether.optin_type = optInTypes[0].value;
            }
            self.getTethers();
            self.getEventActions();
            self.getShortcodes();
            self.getKeywords();
            self.getExperiences();
            self.getLists();
        };

        self.createTether = function () {
            listenerService.createListener(self.tether)
                .then(onCreateListener, onCreateError);
        };

        let onCreateListener = function () {
            $location.hash('create-top');
            $anchorScroll();
            self.isCreateOpen = false;
            self.getTethers();
        };

        let onCreateError = function (data) {
            self.createErrors = data.data.errors;
            // Assign errors to create listener error object
        };

        self.isEditing = function (tetherId) {
            if (self.editingTethers[tetherId] == undefined) {
                self.editingTethers[tetherId] = {};
            }
            if (self.editingTethers[tetherId].isOpen == undefined) {
                self.editingTethers[tetherId].isOpen = true;
            } else {
                self.editingTethers[tetherId].isOpen = !self.editingTethers[tetherId].isOpen;
            }
        };

        self.updateTether = function (index) {
            self.currentTetherId = self.tethers[index].id;
            listenerService.updateListener(self.tethers[index])
                .then(onUpdateListener, onUpdateError);
        };

        let onUpdateListener = function () {
            self.getTethers();
            // Close section
            self.isEditing(self.currentTetherId);
        };

        let onUpdateError = function (data) {
            self.updateErrors[self.currentTetherId] = data.data.errors;
        };

        self.deleteTether = function(listenerId) {
            if($window.confirm('Are you sure you want to delete this tether?')) {
                listenerService.deleteListener(listenerId)
                    .then(onListenerDelete, onError);
            }
        };

        let onDelete = function (data) {
            self.getTethers();
        };

        self.getTethers = function (pageNumber) {
            if (pageNumber == undefined) {
                pageNumber = 1;
            }
            let requestData = {};
            requestData.page = pageNumber;
            requestData.campaign_id = self.campaignId;
            listenerService.getCampaignListeners(requestData)
                .then(onTethers, onError);
        };

        let onTethers = function (data) {
            self.pagination = {};
            self.tethers = data.data;
            self.loadStatus = true;
            let pages = [];
            let firstNumber = ((data.current_page - 2) <= 0) ? 1 : data.current_page - 2;
            let lastNumber = firstNumber + 4;
            if (lastNumber > data.last_page) {
                lastNumber = data.last_page;
            }
            for(let i = firstNumber; i <= lastNumber; i++) {
                pages.push(i);
            }
            self.pagination.range = pages;
            self.pagination.total = data.total;
            self.pagination.current_page = data.current_page;
            self.pagination.last_page = data.last_page;
            self.pagination.next_page_url = data.next_page_url;
            self.pagination.prev_page_url = data.prev_page_url;
            self.pagination.from = data.from;
            self.pagination.to = data.to;
        };

        self.getEventActions = function () {
            eventActionService.indexEventAction()
                .then(onIndexEventAction, onError);
        };

        let onIndexEventAction = function (data) {
            self.events = data;
            if (self.events != undefined) {
                self.tether.event_action_id = data[0].id;
            }
        };

        self.getShortcodes = function () {
            shortcodeService.indexShortcode()
                .then(onShortcode, onError);
        };

        let onShortcode = function (data) {
            self.shortcodes = data;
        };

        self.getKeywords = function () {
            keywordService.indexKeyword()
                .then(onKeyword, onError);
        };

        let onKeyword = function (data) {
            self.keywords = data;
        };

        self.getExperiences = function () {
            experienceService.indexExperience()
                .then(onExperience, onError);
        };

        let onExperience = function (data) {
            self.experiences = data;
        };

        self.getLists = function () {
            listService.indexList()
                .then(onList, onError);
        };

        let onList = function (data) {
            self.lists = data;
        };

        self.openCreate = function () {
            self.isCreateOpen = !self.isCreateOpen;
        };

        let onError = function (data) {
            // console.log('Error occurred');
        };
        // END: CAMPAIGN PAGE

        // START: DIALOG
        let DialogController = function ($scope, $mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };
        };
        // END: DIALOG
    }
]);
